import { Checkbox, type CheckboxProps, FormControlLabel, type FormControlLabelProps } from "@mui/material";
import { Controller, type FieldPath, type FieldValues, type UseControllerProps } from "react-hook-form";

export type TCheckboxFormProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = Omit<
  CheckboxProps,
  "name" | "checked" | "onBlur" | "defaultValue" | "onChange"
> &
  UseControllerProps<TFieldValues, TName> & {
    label: string;
    slotProps?: { formControlLabelProps?: FormControlLabelProps };
  };

export const CheckboxForm = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  name,
  rules,
  shouldUnregister,
  control,
  label,
  defaultValue,
  slotProps,
  ...props
}: TCheckboxFormProps<TFieldValues, TName>) => {
  return (
    <Controller
      name={name}
      rules={rules}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          {...slotProps?.formControlLabelProps}
          checked={field.value}
          name={field.name}
          onChange={field.onChange}
          onBlur={field.onBlur}
          control={<Checkbox {...props} />}
          label={label}
        />
      )}
    />
  );
};
